module.exports = __webpack_public_path__ + "static/media/spanish-adjectives-table-3.7685d240.JPG";